import React, { useState } from "react";
import Layout from "../layout";
import Products from "./products";
import TopSales from "./topsales";
import AllTop from "./alltopproducts";

import Faq from "./faq";

import FollowUs from "./followus";
import HomeCarousol from "./homecarousolo";

import OurPartners from "./outpartners";
import ClientReviews from "./joinus";
import CounterWidget from "./numbercounter";
import EventCarousel from "./eventcarousol";

const Home = () => {
  return (
    <>
      {/* section 2 */}
      <EventCarousel />

      {/* section 3 */}
      <Products />
      {/* section 4 */}
      <TopSales />
      {/* section 5 */}
      <AllTop />

      {/* section 6  */}
      {/* <WatchShop /> */}
      {/* section 7 */}
      {/* <BlogHome /> */}

      <CounterWidget />
      {/* section 8  */}
      <Faq />
      {/* section 9  */}
      <ClientReviews />

      <OurPartners />
      {/* section 10  */}
      <FollowUs />
    </>
  );
};

export default Home;
